<template>
  <!-- jedan blok recepata za sve slucajeve (TopRecipe i TopRecipeNoImg su tanki omotaci oko ovoga) -->
  <BlockCard
    :title="title"
    :title-to="headingLink"
    :dropdown-items="dropdown ? dropdownItems : []"
    :more-to="showAll ? headingLink : null"
    :height="layout === 'feed' ? 'news' : 'event'"
  >
    <!-- feed: kategorija malim slovima iznad naslova, sa linijom levo (Recepti i Kako pomaze na pocetnoj) -->
    <template v-if="layout === 'feed'">
      <hr class="mt-0" />
      <ol class="activity-feed mb-0 ps-2">
        <RecipeFeedItem v-for="recipe in visibleItems" :key="recipe.id" :recipe="recipe" :item-route="itemRoute" />
      </ol>
    </template>

    <template v-else>
      <RecipeRow v-for="recipe in visibleItems" :key="recipe.id" :recipe="recipe" :show-image="showImage" />
    </template>
  </BlockCard>
</template>

<script setup>
import BlockCard from '~/components/widgets/BlockCard.vue'
import RecipeRow from '~/components/cms/recipe/recipe/RecipeRow.vue'
import RecipeFeedItem from '~/components/cms/recipe/recipe/RecipeFeedItem.vue'

const props = defineProps({
  items: { type: Array, default: () => [] },
  // vidi composables/useItemFilter.ts, npr. { top_recipe: true }
  filter: { type: Object, default: () => ({}) },
  // opseg iz filtrirane liste: offset od kog, najvise limit (0 = do kraja)
  offset: { type: Number, default: 0 },
  limit: { type: Number, default: 0 },
  title: { type: String, default: '' },
  // kuda vodi naslov (objekat rute); podrazumevano lista svih recepata
  titleTo: { type: Object, default: null },
  // ruta pojedinacnog teksta u feed-u (Kako pomaze ima svoju)
  itemRoute: { type: String, default: 'recept-category-title-id' },
  // 'rows': red sa slikom ili bez (kao oglasi); 'feed': kategorija iznad naslova
  layout: { type: String, default: 'rows' },
  showImage: { type: Boolean, default: true },
  // padajuca lista kategorija u gornjem uglu: 'category' | '' (bez liste)
  dropdown: { type: String, default: '' },
  // umesto liste: link "Pogledaj sve" ka naslovu
  showAll: { type: Boolean, default: false },
})

const routePath = useRoutePath()
const { $srbTolat } = useNuxtApp()
const { uniqValuesByKey } = useCollectionUtils()

const filtered = computed(() => filterByFields(props.items, props.filter))

const visibleItems = computed(() =>
  filtered.value.slice(props.offset, props.limit > 0 ? props.offset + props.limit : undefined)
)

const headingLink = computed(() => routePath(props.titleTo || { name: 'recepti-page', params: { page: 1 } }))

const dropdownItems = computed(() =>
  props.dropdown === 'category'
    ? uniqValuesByKey(filtered.value, 'category_name').map((name) => ({
        key: name,
        label: name,
        to: routePath({ name: 'recepti-category-page', params: { category: $srbTolat.srbTolatPathSlugify(name), page: 1 } }),
      }))
    : []
)
</script>
